import Button from '@mui/material/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useTerminateEmergencyMode } from '~/hooks/api/useTerminateEmergencyMode';
import { useState } from 'react';
import messages from './messages';
import ConfirmationModal from '../ConfirmationModal';

const ExitEmergencyModeButton = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [shouldShowConfirmationDialog, setShouldShowConfirmationDialog] =
    useState(false);
  const mutation = useTerminateEmergencyMode({
    onSuccess() {
      setShouldShowConfirmationDialog(false);
      showSnackbar({
        message: intl.formatMessage(messages.exitEmergencyModeSuccess),
      });
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.exitEmergencyModeFailure),
      });
    },
  });
  return (
    <>
      <Button
        onClick={() => setShouldShowConfirmationDialog(true)}
        variant="contained"
        color="primary"
      >
        <FormattedMessage {...messages.exitEmergencyMode} />
      </Button>
      <ConfirmationModal
        open={shouldShowConfirmationDialog}
        onCancel={() => setShouldShowConfirmationDialog(false)}
        onConfirm={() => {
          mutation.mutate();
        }}
        cancelLabel={
          <FormattedMessage {...messages.exitEmergencyModeModalCancel} />
        }
        confirmLabel={
          <FormattedMessage {...messages.exitEmergencyModeModalConfirm} />
        }
        title={<FormattedMessage {...messages.exitEmergencyModeModalTitle} />}
        text={
          <FormattedMessage {...messages.exitEmergencyModeModalDescription} />
        }
      />
    </>
  );
};

export default ExitEmergencyModeButton;
